/* eslint-disable no-shadow */
export enum NotificationStatus {
  'read' = 'read',
  'delivered' = 'delivered',
}

export enum receiverSdk {
  'intercomSdk' = 'intercom_sdk',
}

export const notificationStatusKey = {
  '-1': 'NOT_DETERMINED',
  '0': 'DENIED',
  '1': 'AUTHORIZED',
  '2': 'PROVISIONAL',
};

export enum NotiificationId {
  disableBackground = 'disableBackground',
}
